module.exports = __webpack_public_path__ + "img/Dive@2x.8c2a72de.png";